import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { StyleSheet, View } from 'react-native';
import { RadioButton } from 'react-native-paper';

import Text from '../Text';

export type RadioButtonInputFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
};

const RadioButtonInputField = <T extends FieldValues>({ name, control, label }: RadioButtonInputFieldProps<T>) => (
  <View>
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <View>
          <View style={styles.mainContainer}>
            <RadioButton.Android
              value={field.value}
              status={!!field.value ? 'checked' : 'unchecked'}
              color="black"
              onPress={() => field.onChange(!field.value)}
            />
            <Text style={styles.labelText}>{label}</Text>
          </View>
          {error?.message !== undefined ? <Text style={styles.errorText}>{error?.message}</Text> : <></>}
        </View>
      )}
    />
  </View>
);

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  labelText: {
    fontSize: 14,
    fontWeight: '400'
  },

  errorText: {
    marginTop: 10,
    fontSize: 12,
    color: 'red'
  }
});

export default RadioButtonInputField;
